module.exports = __webpack_public_path__ + "img/img7.d3c4b1eb.svg";